module.exports = __webpack_public_path__ + "img/CustomDashboard.394aaebe.svg";